import React from "react"
import '@grapecity/wijmo.styles/wijmo.css';
import * as wjGrid from '@grapecity/wijmo.react.grid';
import '@grapecity/wijmo.cultures/wijmo.culture.ja';
import { FlexGridFilter } from "@grapecity/wijmo.react.grid.filter";
import { Typography } from "@material-ui/core";
import { CollectionViewNavigator } from "@grapecity/wijmo.react.input";
import { CellMaker } from "@grapecity/wijmo.grid.cellmaker";
import '../../../static/css/QAListResult.css'
import { CollectionView } from '@grapecity/wijmo';


interface ResultCRProp {
  open: boolean,
  data: CollectionView<any> | string,
  transQAEdit: (ctx: any, event: any, menuEditId: string) => void,
  headerRef: React.MutableRefObject<null>,
  tableTitle:string,
}

const menuQaEdit = process.env.REACT_APP_MENU_CR_QA_EDIT!

export const Resultcustomer: React.FC<ResultCRProp> = (props) => {
  const { open, data, transQAEdit, headerRef,tableTitle } = props

  const handleResult = (): JSX.Element => {
    if (open) {
      return <React.Fragment>
        <CollectionViewNavigator headerFormat="{current:n0} / {count:n0} ページ" byPage={true} cv={data} ref={headerRef} />
        <wjGrid.FlexGrid id={tableTitle ? 'Home':'QAList'} itemsSource={data} autoRowHeights={true} isReadOnly={true} selectionMode="None">
          <FlexGridFilter />
          <wjGrid.FlexGridColumn header="質問番号" binding="qaNo" wordWrap={true} width="*" minWidth={100} cellTemplate={CellMaker.makeButton({
            click: (event: any, ctx) => transQAEdit(ctx, event, menuQaEdit)
          })} />
          <wjGrid.FlexGridColumn header="契約項目" binding="keiyakuClsName" width="3*" minWidth={50} wordWrap={true} />
          <wjGrid.FlexGridColumn header="タイトル" binding="qaTitle" width="3*" minWidth={50} wordWrap={true} />
          <wjGrid.FlexGridColumn header="質問者" binding="qPersonName" wordWrap={true} width="*" minWidth={50} />
          <wjGrid.FlexGridColumn header="登録日" binding="createDate" format="d" wordWrap={true} width="*" minWidth={50} />
          <wjGrid.FlexGridColumn header="更新日" binding="updateDate" format="d" wordWrap={true} width="*" minWidth={50} />
          <wjGrid.FlexGridColumn header="ステータス" binding="qaStatusClsName" wordWrap={true} width="*" minWidth={50} />
        </wjGrid.FlexGrid>
      </React.Fragment>
    } else {
      return <Typography variant="h6" align='center'>{data}</Typography>
    }
  }
  return (handleResult())
}


